import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// We use GSAP ScrollTrigger to wait till the carousel is in view and then scroll it horizontally as the user scrolls down/up the page. The way we've written the code below means the user will always get to see all the logos, as we scrub/tie the animation to how far the user has scrolled.

// Wrapping the our end value in clamp ensures the carousel gets scrolled by the right amount even if it's towards the bottom of the page - so we don't end up with a partially 'scrubbed' animation: https://gsap.com/docs/v3/Plugins/ScrollTrigger/#end

// Defining our scroll amount and end values as functions means they'll be recalculated if the screen is resized. The invalidateOnRefresh bit means the carousel's  amount will be also updated.

let carousels;

function init(carousel) {
  gsap.to(carousel, {
    x() {
      const carouselHorizontalScrollAmount = carousel.scrollWidth - carousel.parentElement.offsetWidth;
      // If carousel is narrower than the window width we don't need to scroll it.
      return carouselHorizontalScrollAmount <= 0 ? 0 : -carouselHorizontalScrollAmount;
    },
    ease: "none",
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger: carousel,
      scrub: 1,
      start: "bottom bottom",
      end() {
        const header = document.getElementById('header');
        return `clamp(top top+=${header.offsetHeight})`;
      } 
    }
  });
}

export default function() {
  // Exit the function if a logo carousel module isn't present on the page.
  carousels = document.querySelectorAll('.js-module-carousel-logos');
  if (!carousels) return;
  carousels.forEach(carousel => init(carousel));
}
